<template>
  <v-text-field
    :modelValue="modelValue"
    v-bind="$attrs"
    @click="$attrs.click ? '' : (modalCalendar_range = true)"
    :style="isOnMobile ? 'font-size: 12px;' : ''"
    :class="IF.MyFont"
    class="t-date-time-range-picker mytextfield ma-0 pa-0"
    readonly
    maxlength="20"
    :value="getValue()"
    density="compact"
    hide-details
    @click:clear="clearDates()"
  ></v-text-field>
  <v-dialog v-model="modalCalendar_range" persistent width="290px">
    <v-date-picker v-model="dates" :title="title" :multiple="'range'" :min="min.toStringWithFormat('yyyy-MM-dd')" :max="max.toStringWithFormat('yyyy-MM-dd')">
      <template v-slot:actions>
        <v-col class="ma-0 pa-0">
          <t-divider></t-divider>
          <v-row class="ma-0 pa-1" justify="center">
            <v-btn class="ma-1 pa-1 px-2" rounded variant="outlined" small @click="setDates(0)">Днес</v-btn>
            <v-btn class="ma-1 pa-1 px-2" rounded variant="outlined" small @click="setDates(1)">Вчера</v-btn>
            <v-btn class="ma-1 pa-1 px-2" rounded variant="outlined" small @click="setDates(2)">Седмицата</v-btn>
            <v-btn class="ma-1 pa-1 px-2" rounded variant="outlined" small @click="setDates(3)">Този месец</v-btn>
            <v-btn class="ma-1 pa-1 px-2" rounded variant="outlined" small @click="setDates(4)">Миналия месец</v-btn>
          </v-row>
          <t-divider></t-divider>
          <v-row class="ma-1 pa-1">
            <v-spacer></v-spacer>
            <v-btn
              class="ma-1 pa-0"
              :width="100"
              text
              variant="outlined"
              :style="'background: ' + Colors.MenuColor"
              :class="Colors.MenuColor + '--text'"
              @click="cancelInput()"
              >Отказ</v-btn
            >
            <v-btn
              class="ma-1 pa-0"
              :width="100"
              text
              variant="outlined"
              :style="'background: ' + Colors.MenuColor"
              :class="Colors.MenuColor + '--text'"
              @click="handleInput()"
              >OK</v-btn
            >
          </v-row>
        </v-col>
      </template>
      <template v-slot:title>
        <span style="font-size: 16px; letter-spacing: normal">{{ title }}</span>
      </template>
      <template v-slot:header="{}">
        <t-divider></t-divider>
        <v-card-title>{{ datesText }}</v-card-title>
      </template>
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    classProp: {
      type: String,
      default: "",
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    min: {
      type: Date,
      default: () => new Date().addMonths(-24),
    },
    max: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      modalCalendar_range: false,
      dates: [...this.modelValue],
      datesLast: [...this.modelValue],
      datePicker: undefined,
    };
  },
  methods: {
    setDates(type) {
      var date = new Date().getDateWithoutTime();
      this.dates = [];
      //this.$forceUpdate();
      switch (type) {
        case 0:
          this.dates.push(date);
          break;

        case 1:
          this.dates.push(date.addDays(-1));
          break;

        case 2:
          var st = date.getMonday();
          var ee = date;
          while (ee >= st) {
            this.dates.push(st);
            st = st.addDays(1);
          }
          break;

        case 3:
          var start = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0);
          var end = date;
          while (end >= start) {
            this.dates.push(start);
            start = start.addDays(1);
          }
          break;

        case 4:
          var start2 = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).addMonths(-1);
          var end2 = new Date(date.getFullYear(), date.getMonth(), 1).addDays(-1);
          while (end2 >= start2) {
            this.dates.push(start2);
            start2 = start2.addDays(1);
          }
          break;
      }
      this.$forceUpdate();
    },
    clearDates() {
      this.dates = [];
      this.handleInput(true);
    },
    getValue() {
      return (
        (this.datesLast[0] ? new Date(this.datesLast[0]).toStringWithFormat("dd.MM.yyyy") + " - " : "") +
        (this.datesLast[this.datesLast.length - 1] ? new Date(this.datesLast[this.datesLast.length - 1]).toStringWithFormat("dd.MM.yyyy") : "")
      );
    },
    cancelInput() {
      this.dates = [...this.datesLast];
      this.modalCalendar_range = false;
      this.$emit("cancel", [...this.dates]);
    },
    handleInput(cancel) {
      if (!cancel && !this.dates[0]) {
        this.dialog.showError("Не сте избрали нищо!");
        return;
      }
      if (this.dates.length == 1) {
        this.dates.push(this.dates[0]);
      }

      if (!cancel) {
        this.dates[this.dates.length - 1] = this.dates[this.dates.length - 1].getDateWithoutTime().addDays(1).addMilliseconds(-1);
      }
      this.datesLast = [...this.dates];

      this.$emit("update:modelValue", [...this.dates]);
      this.$emit("input", [...this.dates]);
      this.$emit("change", [...this.dates]);
      this.modalCalendar_range = false;
    },
  },
  computed: {
    datesText() {
      if (this.dates.length == 0) {
        return "Моля изберете период";
      } else {
        return this.dates[0].toStringWithFormat("dd.MM.yyyy") + " - " + this.dates[this.dates.length - 1].toStringWithFormat("dd.MM.yyyy");
      }
    },
  },
  watch: {},
  mounted() {},
};
</script>
<style scoped>
.t-date-time-range-picker >>> input {
  cursor: pointer;
}

.t-date-time-range-picker /deep/ .v-field__input {
  padding-left: 8px;
  padding-right: 8px;
}
</style>